import styled from 'styled-components';

const VideoContainer = styled.video`
	width: 100%;
`;
export default VideoContainer;
